<i18n lang='yml' src='../i18n/ManageSurvey.yml'></i18n>

<template>
  <div v-if="loading">
    <loading-animation-vue></loading-animation-vue>
  </div>
  <div v-else>
    <flash :message_type="message_type" :message_text="message_text"/>
    <form @submit.prevent="submitSurveyData">
      <div class="row">
        <div class="col-sm-12 survey-management">
          <div class="action-bar border-bottom dotted clearfix">
            <div>
              <a @click.prevent="createQuestion(1)" class="btn btn-sm btn-primary" href="#">
                <font-awesome-icon :icon="['fa', 'plus']"/>
                {{ $t('new_question') }}
              </a>
            </div>
            <div class="ml-auto">
              <a @click.prevent="submitSurveyData" class="btn btn-sm btn-success" href="#">
                <font-awesome-icon :icon="['fa', 'save']" />
                {{ $t('save_questions') }}
              </a>
              <!-- Cancel button not intended to redirect user to different page-->
              <a class="btn btn-sm btn-light" href="">
                <font-awesome-icon :icon="['fa', 'times']" />
                {{ $t('cancel_button') }}
              </a>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="border-bottom dotted">
            <template v-if="loading">
              <p> {{ $t('loading') }} </p>
            </template>
            <template v-if="questions.length === 0">
              <p class="alert alert-info no-margin">{{ $t('no_questions_yet') }}
              </p>
            </template>
            <template v-else>
              <div v-for="(question, index) in questions" v-bind:key="question.id" class="row survey-question-wrapper">
                <div class="col-sm-12">
                  <div class="border-bottom">
                    <div class="form-group row">
                      <div class="col-sm-12">
                        <label for="questionTitle">{{ $t('new_question_title') }}</label>
                        <input v-model="question.title" type="text" :placeholder="$t('new_question_placeholder')" class="form-control" id="questionTitle">
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-6">
                        <div class="checkbox">
                          <label>
                            <input type="checkbox" v-model="question.required" :value="1"> {{ $t('required_question') }}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-6">
                        <label for="questionType">{{ $t('question_types.header') }}</label>
                        <select id="questionType" v-model="question.type" class="form-control">
                          <option :value="0">{{ $t('question_types.select_one') }}</option>
                          <option :value="1"> {{ $t('question_types.select_multiple') }}</option>
                          <option :value="2"> {{ $t('question_types.text') }}</option>
                        </select>
                      </div>

                      <div class="col-sm-6" v-if="question.type === 2">
                        <label for="validationType">{{ $t('validation_types.header') }}</label>
                        <select id="validationType" v-model="question.validationType" class="form-control">
                          <option :value="null">None</option>
                          <option :value="0">{{ $t('validation_types.email') }}</option>
                          <option :value="1"> {{ $t('validation_types.date') }}</option>
                          <option :value="2"> {{ $t('validation_types.phone') }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-12">
                        <p class="label-p">{{ $t('selected_roles')}}</p>
                        <template v-for="role in roles" :key="role.id">
                          <div class="checkbox-inline">
                            <label>
                              <input type="checkbox" v-model="question.roles" :value="role.id" /> {{role.name_en}}
                            </label>
                          </div>
                        </template>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-12">
                        <label :for='`questionPosition_${question.position}`'> {{ $t('position')}} </label>
                        <select v-model="question.position" :id='`questionPosition_${question.position}`'
                                @change="updatePosition(question)">
                          <option v-for="p in questions.length" :value="p" v-bind:key="p"> {{p}} </option>
                        </select>
                      </div>
                    </div>
                    <div v-if="isOptionQuestion(question)" class="form-group row">
                      <div class="col-sm-12">
                        <p class="label-p">{{ $t('define_options') }}</p>
                        <div class="margin-bottom row" v-for="(answer, index) in question.answers" v-bind:key="answer.id" >
                          <!-- TODO: Add dynamic labels -->
                          <!-- Dynamic labels can be hidden visually using .sr-only so they don't clutter UI -->
                          <div class="col-sm-11">
                            <input v-model="answer.answer_text" type="text" :placeholder="$t('new_answer_placeholder')" class="form-control"/>
                          </div>
                          <div class="col-sm-1">
                            <a class="btn btn-danger btn-sm" v-on:click="deleteAnswer(question, index)">x</a>
                          </div>
                        </div>
                        <a @click.prevent="createAnswer(question)" class="btn btn-primary btn-sm"  href="#">
                          <font-awesome-icon :icon="['fa', 'plus']" />
                          {{ $t('add_answer') }}
                        </a>
                      </div>
                    </div> 
                    <a @click.prevent="deleteQuestion(question, index)" class="btn btn-danger" href="#">
                        <font-awesome-icon :icon="['fa', 'trash-alt']" />
                        {{ $t('delete_question') }}
                    </a>
                    <div class="clearfix"></div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="action-bar border-bottom light clearfix">
            <div>
              <a @click.prevent="createQuestion(questions.length+1)" class="btn btn-primary btn-sm" href="#">
                <font-awesome-icon :icon="['fa', 'plus']" />
                {{ $t('new_question') }}
              </a>
            </div>
            <div class="ml-auto">
              <a @click.prevent="submitSurveyData" class="btn btn-success btn-sm" href="#">
                <font-awesome-icon :icon="['fa', 'save']" />
                {{ $t('save_questions') }}
              </a>
              <!-- Cancel button not intended to redirect user to different page-->
              <a class="btn btn-sm btn-light" href="">
                <font-awesome-icon :icon="['fa', 'times']" />
                {{ $t('cancel_button') }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import flash from '../../shared/flash_messages/components/Flash.vue';
  import { sendAjaxRequest } from '../../shared/typescripts/ajax.ts'

  export default {
    props: {
        api_path: { type: String },
        load_path: { type: String },
        available_roles: { type: String },
    },

    components: {
      flash
    },

    data() {
        return {
            loading: true,
            questions: [],
            roles: JSON.parse(this.available_roles),
            message_text: [],
            message_type: ""
        };
    },
    methods: {
        createQuestion(position) {
            this.questions.forEach((question) => {
                if (question.position >= position) {
                    question.position += 1;
                    question.oldPosition += 1;
                }
            });

            let data = {
                position: position,
                oldPosition: position,
                id: null,
                validationType: null,
                required: false,
                title: "",
                type: 3,
                answers: [],
                roles: [],
            }

            this.questions.splice(position - 1, 0, data);
        },
        updatePosition(passedQuestion) {
            const newPosition = parseInt(passedQuestion.position.toString(), 10);
            const oldPosition = parseInt(passedQuestion.oldPosition.toString(), 10);

            this.questions.forEach((q) => {
                if (q === passedQuestion) {
                    return;
                }

                if(oldPosition < newPosition) {
                    if(q.position > oldPosition) {
                        if (q.position <= newPosition) {
                            q.position = q.oldPosition = q.oldPosition - 1;
                        }
                    }
                } else {
                    if(q.position >= newPosition) {
                        if (q.position <= oldPosition) {
                            q.position = q.oldPosition = q.oldPosition + 1;
                        }
                    }
                }
            });

            passedQuestion.oldPosition = newPosition;
        },
        scrollToEnd: function() {
            var y = document.body.scrollHeight;
            window.scrollTo(0,y);
        },

        createAnswer(question) {
            question.answers.push({
                id: null,
                answer_text: ""
            });
        },
        deleteAnswer(question, index) {
            question.answers.splice(index, 1);
        },

        isOptionQuestion(question) {
            return [0, 1].includes(question.type);
        },

        removeUnsavedQuestion(index){
          this.questions.forEach(question => {
                question.position += 1;
            });

          this.questions.splice(index, 1);
        },

        deleteQuestion(question, index){
            if(question.id && confirm(this.$i18n.t('confirm_delete'))) {
              sendAjaxRequest('DELETE',`${this.api_path}/destroy_question/${question.id}`, 'json', {}, this.deleteQuestionSuccess, this.throwError )
          }
          else if(!question.id){
            this.removeUnsavedQuestion(index)
          }
        },

        deleteQuestionSuccess() {
          this.fetchQuestionData();
          this.loading = false;
          this.message_type = "notice";
          this.message_text = [this.$t("success_deleting")];
        },

        throwError() {
          this.message_type = "error";
          this.message_text = [this.$t("error_deleting")];
          console.log(response);
        },

        submitSurveyData() {
            let payload = {
                survey_questions: []
            };

            this.questions.forEach((question) => {
                let question_data = {
                    position: question.position,
                    title: question.title,
                    id: question.id,
                    type: question.type,
                    validation_type: question.validationType,
                    required: question.required,
                    answers: [],
                    roles: question.roles,
                };

                question.answers.forEach((answer) => {
                    question_data.answers.push({
                        id: answer.id,
                        answer_text: answer.answer_text,
                    });
                });

                payload.survey_questions.push(question_data);
            });

            sendAjaxRequest('PUT', this.api_path, 'json', payload, this.submitSuccess, this.submitError )
        },

        submitError() {
          alert(this.$t('error_saving'));
          console.log(response);
        },

        submitSuccess() {
          this.fetchQuestionData();
          this.loading = false;
          alert(this.$t("success_saving"));
        },

        loadSurveyData(data) {
            this.questions = [];
            data.forEach((item) => {
                let questionData = {
                    position: item.position,
                    oldPosition: item.position,
                    id: item.id,
                    title: item.title,
                    type: item.type,
                    required: item.required,
                    validationType: item.validation_type,
                    answers: item.answers,
                    roles: item.roles
                };
                  
                this.questions.push(questionData);
            });

            this.questions.sort((a,b) => a.position - b.position);
        },

        fetchQuestionData() {
          sendAjaxRequest('GET', this.load_path, 'json', {}, this.fetchSuccess, this.fetchError);
        },

        fetchSuccess(response) {
          if(response != null){
            this.loadSurveyData(response);
          }
          this.loading = false;
        },

        fetchError() {
          alert('Error loading onboarding questions. :(');
          console.log(response);
        }
    },
    mounted() {
        this.loading = true;
        this.fetchQuestionData();
    },
  };
</script>
